import React, { useMemo } from 'react';
import {
  CsvUploadConfigurationContext,
  CsvUploadConfigurationContextProps,
  csvUploadConfigurationSlice,
} from '../context/CsvUploadConfigurationContext';
import { CsvUploadConfiguration } from '../types/csvUploadConfiguration';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';

interface CsvUploadConfigurationProviderProps {
  children: React.ReactNode;
}

export default function CsvUploadConfigurationProvider({ children }: CsvUploadConfigurationProviderProps) {
  const dispatch = useAppDispatch();
  const items = useAppSelector(state => state.csvUploadConfigurations.items);
  const loading = useAppSelector(state => state.csvUploadConfigurations.loading);

  const csvUploadConfigurations = useMemo(() => {
    return new Map(items.map(item => [item.id, new CsvUploadConfiguration(item)]));
  }, [items]);

  const csvUploadConfigurationContext: CsvUploadConfigurationContextProps = {
    csvUploadConfigurations,
    csvUploadConfigurationsLoading: loading,
    setCsvUploadConfigurations: (csvUploadConfigurations: Map<string, CsvUploadConfiguration>) =>
      dispatch(csvUploadConfigurationSlice.actions.setAll([...csvUploadConfigurations.values()])),
  };

  return (
    <CsvUploadConfigurationContext.Provider value={csvUploadConfigurationContext}>
      {children}
    </CsvUploadConfigurationContext.Provider>
  );
}
